export default __webpack_public_path__ + "static/media/Boots of Vicious Frenzy.d2938acb.jpg";